import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "spinner", "status", "submitButton"]

  connect() {
    this.uploadCount = 0
    this.completedCount = 0

    this.inputTarget.addEventListener("direct-upload:initialize", this.uploadInitialized.bind(this))
    this.inputTarget.addEventListener("direct-upload:start", this.uploadStarted.bind(this))
    this.inputTarget.addEventListener("direct-upload:end", this.uploadEnded.bind(this))
    this.inputTarget.addEventListener("direct-upload:error", this.uploadError.bind(this))
  }

  disconnect() {
    this.inputTarget.removeEventListener("direct-upload:initialize", this.uploadInitialized.bind(this))
    this.inputTarget.removeEventListener("direct-upload:start", this.uploadStarted.bind(this))
    this.inputTarget.removeEventListener("direct-upload:end", this.uploadEnded.bind(this))
    this.inputTarget.removeEventListener("direct-upload:error", this.uploadError.bind(this))
  }

  uploadInitialized(event) {
    this.uploadCount = this.inputTarget.files.length
    this.completedCount = 0
    this.showSpinner()
    this.updateStatus(t("javascript.controllers.file_upload_spinner_controller.preparing_upload", { count: this.uploadCount }))
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true
    }
  }

  uploadStarted(event) {
    this.updateStatus(t("javascript.controllers.file_upload_spinner_controller.uploading_file_of", { current: this.completedCount + 1, total: this.uploadCount }))
  }

  uploadEnded(event) {
    this.completedCount++
    if (this.completedCount === this.uploadCount) {
      this.hideSpinner()
      if (this.hasSubmitButtonTarget) {
        this.submitButtonTarget.disabled = false
      }
    } else {
      this.updateStatus(t("javascript.controllers.file_upload_spinner_controller.uploading_file_of", { current: this.completedCount + 1, total: this.uploadCount }))
    }
  }

  uploadError(event) {
    event.preventDefault()
    this.completedCount++ // Count it as "processed"
    const { id, error } = event.detail
    this.updateStatus(t("javascript.controllers.file_upload_spinner_controller.error_uploading_file", { error }), true)
    // Don't hide the spinner until all files are processed
    if (this.completedCount === this.uploadCount) {
      // Maybe hide after a delay to let user see the error
      setTimeout(() => {
        this.hideSpinner()
        if (this.hasSubmitButtonTarget) {
          this.submitButtonTarget.disabled = false
        }
      }, 5000)
    }
  }

  showSpinner() {
    this.spinnerTarget.classList.remove("hidden")
  }

  hideSpinner() {
    this.spinnerTarget.classList.add("hidden")
  }

  updateStatus(message, isError = false) {
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = message
      this.statusTarget.classList.toggle("text-red-400", isError)
      this.statusTarget.classList.toggle("text-blue-300", !isError)
    }
  }
}
